<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('contact') }}
    </h1>
  
    <div class="main_wrap">
        <div class="mobiSection">
            <!-- <div class="mobiSection__header">
                <h2 class="mobiTitle md text_color"><span>Contact Us</span></h2>
                
                </div> -->
            <div class="mobiSection__content">
                <div class="mobiForm">
                     <h2 class="mobiTitle md text_color"><span>{{$t("contact_us")}}</span></h2>
                     <div class="mobiForElm">
                         <label>{{$t("subject")}}</label>
                        <div class="mobiForElm__wrap">
                             <select id="select" >
                            <option>{{$t("select_subject")}}</option>
                            <option value="technical">{{$t("app_issue")}}</option>
                            <option value="content">{{$t("content")}}</option>
                             <option value="subscription">{{$t("subscription")}}</option>
                        </select>
                        <span class="arrow__upper"></span>
                        </div>
                    </div>
                    <div class="mobiForElm lg">
                         <label>{{$t("message")}}</label>
                         <textarea rows="4" cols="50"  :placeholder="$t('let_us')"></textarea>
                    </div>

                </div>
                 <div class="btnContainer">
                        <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
                </div>
             
            </div>
        </div>
    </div>  
    
  </div>
</template>

<script>
export default {
  methods: {
  }
};
</script>

<style scoped lang="scss">
.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/prizeo/Contact.vue